import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  template: `
    <div class="form-group">
      <label *ngIf="!!label" for="{{ id }}">{{ label }}</label>
      <label *ngIf="!!limit && !!label" class="pull-right">{{ _text ? _text.length : 0 }}/{{ limit }}</label>
      <input
        *ngIf="type == 'text'"
        type="text"
        class="form-control"
        id="{{ id }}"
        [attr.maxLength]="maxLength()"
        [(ngModel)]="text"
      />
      <textarea
        *ngIf="type == 'textarea'"
        class="form-control"
        id="{{ id }}"
        [attr.maxLength]="maxLength()"
        [(ngModel)]="text"
        rows="5"
      ></textarea>
    </div>
  `,
  styles: [
    `
      .form-control {
        border: none;
        border-radius: 10px;
      }
    `
  ],
  selector: 'input-text'
})
export class InputTextComponent implements OnInit, OnDestroy {
  @Input('label') public label: string;
  @Input('limit') public limit: number;
  @Input('type') public type: 'text' | 'textarea';

  @Input('text') public _text: string;
  @Output() textChange = new EventEmitter<string>();

  public id: string;

  constructor() {}

  public get text(): string {
    return this._text;
  }

  public set text(v: string) {
    this._text = v;
    this.textChange.emit(this._text);
  }

  ngOnInit() {
    this.id = '_id_' + Math.floor(Math.random() * 999 + 100);
  }

  ngOnDestroy(): void {}

  maxLength() {
    return (typeof this.limit === 'undefined') ? null : this.limit;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/common-livee/input-text.component.ts